import { render, staticRenderFns } from "./FailedChain.vue?vue&type=template&id=5db208fc&scoped=true&"
import script from "./FailedChain.vue?vue&type=script&lang=js&"
export * from "./FailedChain.vue?vue&type=script&lang=js&"
import style0 from "./FailedChain.vue?vue&type=style&index=0&id=5db208fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db208fc",
  null
  
)

export default component.exports